import { DataObjectValueType } from '../api';

/**
 * Calculates size of a value.
 * - Arrays & strings: length
 * - Objects: number of keys
 * - Otherwise: -1
 */
export const size = (value: DataObjectValueType): number => {
  if (value == null) {
    return -1;
  }

  if (Array.isArray(value) || typeof value === 'string') {
    return value.length;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length;
  }

  return -1;
};
